import { memoize } from "lodash-es";
import { getTenantNamespace } from "./tenant.js";
const getBootFlag = memoize(_getBootFlag);
function _getBootFlag(flag) {
    try {
        const windowValues = parent.chronoBootFlags;
        if (!isJsObject(windowValues)) throw new Error(`Expected a JavaScript object for BootFlags but received '${windowValues}'`);
        if (!(flag.key in windowValues)) throw new Error(`Key '${flag.key}' is missing from BootFlag values`);
        const valueFromWindow = windowValues[flag.key];
        if (!flag.isValid(valueFromWindow)) throw new Error(`Invalid value '${valueFromWindow}' for flag '${flag.key}'`);
        return valueFromWindow;
    } catch (err) {
        const fallbackValue = 'function' == typeof flag.defaultValue ? flag.defaultValue() : flag.defaultValue;
        console.error(`Using default value '${fallbackValue}' for BootFlag '${flag.key}'`, err);
        return fallbackValue;
    }
}
function sentryDefault() {
    const isRcEnvironment = getTenantNamespace().startsWith('rc-');
    return isRcEnvironment ? 'disabled' : 'enabled';
}
const BootFlags = {
    FULL_STORY_MODE: stringUnionFlag('fullStoryMode', 'disabled', [
        'enabled',
        'disabled',
        'relayed'
    ]),
    SENTRY_MODE: stringUnionFlag('sentryMode', sentryDefault, [
        'enabled',
        'disabled'
    ]),
    DOORBELL_MODE: stringUnionFlag('doorBellMode', 'disabled', [
        'internal',
        'external',
        'disabled'
    ]),
    NETWORK_MONITORING_ENABLED: stringUnionFlag('networkMonitoringEnabled', 'false', [
        'true',
        'false'
    ]),
    CHAMELEON_MODE: stringUnionFlag('chameleonMode', 'disabled', [
        'enabled',
        'disabled'
    ])
};
function stringUnionFlag(key, defaultValue, validValues) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>{
            for (const valid of validValues)if (windowValue === valid) return true;
            return false;
        }
    };
}
function booleanFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'boolean' == typeof windowValue
    };
}
function numberFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'number' == typeof windowValue
    };
}
function stringFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'string' == typeof windowValue
    };
}
function isJsObject(val) {
    return 'object' == typeof val && null !== val && false === Array.isArray(val);
}
export { BootFlags, booleanFlag, getBootFlag, numberFlag, stringFlag, stringUnionFlag };

//# sourceMappingURL=boot-flags.js.map